import ClashRegister from "./sub_tabs/ClashRegister";
import { History } from "./sub_tabs/History";


const clashesTabRouter = {

  register: 
  {
    title: 'Register',
    element: <ClashRegister />
  },

  history: 
  {
    title: 'History',
    element: <History />
  }

}

export default clashesTabRouter;